module.exports = __webpack_public_path__ + "static/media/steam_icon.429fb792.png";